import { render, staticRenderFns } from "./export-generic-entities-index.vue?vue&type=template&id=081ae855&"
import script from "./export-generic-entities-index.vue?vue&type=script&lang=js&"
export * from "./export-generic-entities-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports